import { defineMessages } from 'utils/intl';

export default defineMessages({
  clearFilters: 'Usuń filtry ({count})',
  showMore: 'Pokaż więcej',
  showLess: 'Pokaż mniej',
  loadMore: 'Wczytaj więcej',
  goToFullSearch: 'Przejdź do pełnej wyszukiwarki',
});
